module.exports = __webpack_public_path__ + "9fc1a98bddbcd2184d5d183150bdbba8.svg";